import { initAll } from 'govuk-frontend'
import './autocomplete'

initAll()
